import { roles } from '@nxsys/store/constants';
import RPNListing from '../../../modules/rpn/listing';

export const rpnConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rpn',
    element: <RPNListing />,
  },
];
